var _defs, _path, _path2, _path3, _path4, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAog131Xxx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 779.53,
    height: 311.81,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    id: "rect4",
    d: "M195.29 42.52h779.53v226.77H195.29z"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#fff}.cls-3{fill:none}.cls-4{fill:#fff200}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "rect9",
    d: "M0 3h779.53v42.52H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "rect11",
    d: "M0 266.11h779.53v42.52H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "rect13",
    d: "M0 0h779.53v42.52H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "rect15",
    d: "M0 269.29h779.53v42.52H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    id: "rect17",
    d: "M0 42.52h779.53v226.77H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    id: "g55",
    transform: "translate(-195.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon19",
    d: "M223.95 42.52h-11.01l226.77 226.77H532.32L305.55 42.52h-11.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon21",
    d: "M365.51 42.52H354.5l226.77 226.77H673.88L447.11 42.52H436.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon23",
    d: "M507.24 42.52h-11.01l226.78 226.77h92.6L588.84 42.52h-11.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon25",
    d: "M648.97 42.52h-11l226.77 226.77H957.35L730.58 42.52h-11.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon27",
    d: "M791.64 42.52h-11.01l226.77 226.77H1100.01L873.24 42.52h-11.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon29",
    d: "M932.97 42.52h-11l226.77 226.77H1241.35L1014.58 42.52h-11.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon31",
    d: "M82.62 42.52H71.61l226.77 226.77H390.99L164.22 42.52h-11.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon33",
    d: "M11.01 114.13H0L226.77 340.9H319.38L92.61 114.13H81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon35",
    d: "M243.18 269.29l-47.89-47.89v47.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon37",
    d: "M303.31 269.29h81.6L195.29 79.67v81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon39",
    d: "M445.05 269.29h81.6L299.87 42.52h-81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon41",
    d: "M586.78 269.29h81.6L441.61 42.52h-81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon43",
    d: "M728.51 269.29h81.6L583.34 42.52h-81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon45",
    d: "M870.24 269.29h81.6L725.07 42.52h-81.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon47",
    d: "M926.93 42.52l47.89 47.89V42.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon49",
    d: "M974.82 232.14v-81.6L866.8 42.52h-81.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAog131Xxx);
export default __webpack_public_path__ + "static/media/AOG131XXX.de0be9901546d1e2905ae6a06d373a9d.svg";
export { ForwardRef as ReactComponent };